(function(){'use strict';const CONFIG={animationDuration:350,animationEasing:'cubic-bezier(0.4, 0.0, 0.2, 1)',};const CLASSES={slideOutLeft:'product-image-slide-out-left',slideOutRight:'product-image-slide-out-right',slideInLeft:'product-image-slide-in-left',slideInRight:'product-image-slide-in-right',animating:'product-block--animating',};const initializedBlocks=new WeakSet();function initCarouselAnimations(productBlock){if(initializedBlocks.has(productBlock))return;initializedBlocks.add(productBlock);const imageContainer=productBlock.querySelector('.image-cont--with-secondary-image');if(!imageContainer)return;let currentActiveImage=productBlock.querySelector('.product-block__image--active');setupDirectionTracking(productBlock,imageContainer);const observer=new MutationObserver((mutations)=>{mutations.forEach((mutation)=>{if(mutation.type==='attributes'&&mutation.attributeName==='class'&&mutation.target.classList.contains('product-block__image')){const targetImage=mutation.target;if(targetImage.classList.contains('product-block__image--active')&&!mutation.oldValue?.includes('product-block__image--active')){const oldImage=currentActiveImage;currentActiveImage=targetImage;handleImageActivation(productBlock,oldImage,targetImage)}}})});const images=productBlock.querySelectorAll('.product-block__image');images.forEach((img)=>{observer.observe(img,{attributes:!0,attributeOldValue:!0,attributeFilter:['class'],})})}
function setupDirectionTracking(productBlock,imageContainer){const nextButton=productBlock.querySelector('.image-page-button--next');const prevButton=productBlock.querySelector('.image-page-button--previous');if(nextButton){nextButton.addEventListener('click',()=>{productBlock.dataset.carouselDirection='next'},{capture:!0})}
if(prevButton){prevButton.addEventListener('click',()=>{productBlock.dataset.carouselDirection='prev'},{capture:!0})}
let touchStartX=null;imageContainer.addEventListener('touchstart',(e)=>{touchStartX=e.touches[0].clientX},{passive:!0,capture:!0});imageContainer.addEventListener('touchmove',(e)=>{if(touchStartX===null)return;const touchCurrentX=e.touches[0].clientX;const deltaX=touchCurrentX-touchStartX;if(deltaX>25){productBlock.dataset.carouselDirection='prev';touchStartX=null}else if(deltaX<-25){productBlock.dataset.carouselDirection='next';touchStartX=null}},{passive:!0,capture:!0});imageContainer.addEventListener('touchend',()=>{touchStartX=null},{passive:!0})}
function handleImageActivation(productBlock,oldActiveImage,newActiveImage){const direction=productBlock.dataset.carouselDirection||'next';delete productBlock.dataset.carouselDirection;applySlideAnimation(productBlock,oldActiveImage,newActiveImage,direction)}
function applySlideAnimation(productBlock,oldImage,newImage,direction){if(productBlock.classList.contains(CLASSES.animating)){return}
productBlock.classList.add(CLASSES.animating);const duration=CONFIG.animationDuration;const easing=CONFIG.animationEasing;const oldTranslateX=direction==='next'?'-100%':'100%';const newTranslateX=direction==='next'?'100%':'-100%';if(oldImage){oldImage.style.setProperty('transition','none','important');const currentOpacity=getComputedStyle(oldImage).opacity;oldImage.style.setProperty('opacity',currentOpacity,'important')}
newImage.style.setProperty('transition','none','important');const newImageOpacity=getComputedStyle(newImage).opacity;newImage.style.setProperty('opacity',newImageOpacity,'important');if(oldImage)oldImage.offsetHeight;newImage.offsetHeight;if(oldImage){oldImage.style.setProperty('z-index','1','important');oldImage.style.setProperty('opacity','1','important');oldImage.style.transform='translateX(0) translateZ(0)'}
newImage.style.setProperty('z-index','2','important');newImage.style.setProperty('opacity','1','important');newImage.style.transform=`translateX(${newTranslateX}) translateZ(0)`;requestAnimationFrame(()=>{requestAnimationFrame(()=>{if(oldImage){oldImage.style.setProperty('transition',`transform ${duration}ms ${easing}`,'important');oldImage.style.transform=`translateX(${oldTranslateX}) translateZ(0)`}
newImage.style.setProperty('transition',`transform ${duration}ms ${easing}`,'important');newImage.style.transform='translateX(0) translateZ(0)'})});setTimeout(()=>{if(oldImage){oldImage.style.setProperty('transition','none','important');oldImage.style.transform='';oldImage.style.zIndex='';oldImage.style.opacity=''}
newImage.style.transform='';newImage.style.transition='';newImage.style.zIndex='';newImage.style.opacity='';productBlock.classList.remove(CLASSES.animating)},duration+50)}
function initializeAll(){const blocks=document.querySelectorAll('product-block');blocks.forEach(initCarouselAnimations)}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initializeAll)}else{initializeAll()}
document.addEventListener('on:quickbuy:after-open',initializeAll);const bodyObserver=new MutationObserver((mutations)=>{mutations.forEach((mutation)=>{mutation.addedNodes.forEach((node)=>{if(node.nodeType===1){if(node.matches&&node.matches('product-block')){initCarouselAnimations(node)}else if(node.querySelectorAll){node.querySelectorAll('product-block').forEach(initCarouselAnimations)}}})})});bodyObserver.observe(document.body,{childList:!0,subtree:!0,})})()

    document.addEventListener('click', function(event) {
  const card = event.target.closest('.product-block');
  if (!card) return;

  const image = card.querySelector('.product-block__image');
  if (!image) return;

  image.classList.remove('ifs-product-clicked');

  void image.offsetWidth;

  image.classList.add('ifs-product-clicked');
});


/* IFS - Préchargement fiable galerie produit */
(function () {
  function initIFSGalleryPreload() {
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      if (gallery.dataset.ifsGalleryPreload === 'true') return;

      var images = Array.from(
        gallery.querySelectorAll('.product-media--image img')
      );

      if (images.length < 2) return;

      gallery.dataset.ifsGalleryPreload = 'true';

      var firstImage =
        images.find(function (img) {
          return img.getAttribute('fetchpriority') === 'high';
        }) ||
        images.find(function (img) {
          return img.getAttribute('loading') === 'eager';
        }) ||
        images[0];

      var firstIndex = images.indexOf(firstImage);

      var remainingImages = images
        .slice(firstIndex + 1)
        .concat(images.slice(0, firstIndex));

      function prepareImage(img, priority) {
        img.loading = 'eager';
        img.fetchPriority = priority;

        function decodeImage() {
          if (typeof img.decode === 'function') {
            img.decode().catch(function () {});
          }
        }

        if (img.complete && img.naturalWidth > 0) {
          decodeImage();
        } else {
          img.addEventListener('load', decodeImage, { once: true });
        }
      }

      function startPreload() {
        remainingImages.forEach(function (img, index) {
          /*
           * Photos 2, 3 et 4 : priorité normale.
           * Photos suivantes : chargement anticipé mais priorité basse.
           */
          prepareImage(img, index < 3 ? 'auto' : 'low');
        });
      }

      /*
       * Important :
       * on ne touche à aucune autre photo tant que
       * la première n'est pas réellement chargée.
       */
      if (firstImage.complete && firstImage.naturalWidth > 0) {
        startPreload();
      } else {
        firstImage.addEventListener('load', startPreload, { once: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIFSGalleryPreload, {
      once: true
    });
  } else {
    initIFSGalleryPreload();
  }
})();